"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var styles = require("spry-react/Grid/gridStyles");
var transitionGroup_1 = require("spry-react/Animation/transitionGroup");
var animation_1 = require("spry-react/Animation/animation");
var BaseGridRow = function (props, ref) {
    var _a;
    var divRef = React.useRef(null);
    React.useImperativeHandle(ref, function () { return ({
        scrollTo: function (duration) {
            if (duration === void 0) { duration = 300; }
            if (divRef.current) {
                Pb.scrollTo($(divRef.current), duration);
            }
        }
    }); });
    var allowSelection = props.allowSelection, isSelected = props.isSelected, isSimpleGrid = props.isSimpleGrid, autoHeight = props.autoHeight;
    var rowClasses = classNames(styles.gridRow, (_a = {},
        _a[styles.gridRowAutoHeight] = autoHeight,
        _a[styles.gridRowSimple] = isSimpleGrid,
        _a[styles.gridRowSelectable] = allowSelection,
        _a[styles.gridRowSelected] = isSelected || false,
        _a));
    return (React.createElement("div", { ref: divRef, className: rowClasses, onClick: props.clickHandler, onDoubleClick: props.doubleClickHandler, onContextMenu: props.rightClickHandler, role: 'row' }, props.cells));
};
exports.GridRow = React.forwardRef(BaseGridRow);
var BaseExpandableGridRow = function (props, ref) {
    var _a;
    var onExpandedContentWillEnter = function () {
        return { visibility: 'hidden' };
    };
    var onExpandedContentDidEnter = function (child, element) {
        return { height: new animation_1.DurationAnimationDefinition(0, element.clientHeight, 400, animation_1.Easing.QuadIn) };
    };
    var onExpandedContentWillExit = function (child, element) {
        return { height: new animation_1.DurationAnimationDefinition(element.clientHeight, 0, 400, animation_1.Easing.QuadOut) };
    };
    var onExpandedContentDoneEntering = function (child, element) {
        return { height: 'auto' };
    };
    var renderExpandedContent = function (child, currentStyle, childRef) {
        return (React.createElement("div", { key: 'expanded-row-content-container', ref: childRef, className: styles.expandedRowContentContainer, style: { height: currentStyle.height, visibility: currentStyle.visibility } },
            React.createElement("div", { className: styles.expandedRowContent }, props.expandedContent)));
    };
    var divRef = React.useRef(null);
    React.useImperativeHandle(ref, function () { return ({
        scrollTo: function (duration) {
            if (duration === void 0) { duration = 300; }
            if (divRef.current) {
                Pb.scrollTo($(divRef.current), duration);
            }
        }
    }); });
    var allowSelection = props.allowSelection, isSelected = props.isSelected, isExpanded = props.isExpanded;
    var rowClasses = classNames(styles.gridRow, (_a = {},
        _a[styles.gridRowSelectable] = allowSelection,
        _a[styles.gridRowSelected] = isSelected || false,
        _a[styles.gridRowExpanded] = isExpanded,
        _a));
    return (React.createElement("div", { className: styles.expandedRowContainer, ref: divRef },
        React.createElement("div", { className: rowClasses, onClick: props.clickHandler, onDoubleClick: props.doubleClickHandler, onContextMenu: props.rightClickHandler }, props.cells),
        React.createElement(transitionGroup_1.TransitionGroup, { key: "grid-expanded-content", data: props.isExpanded ? [{ key: 'expanded-row' }] : [], willEnter: onExpandedContentWillEnter, didEnter: onExpandedContentDidEnter, willExit: onExpandedContentWillExit, doneEntering: onExpandedContentDoneEntering, renderChild: renderExpandedContent })));
};
exports.ExpandableGridRow = React.forwardRef(BaseExpandableGridRow);
